import type React from 'react';
import PeriodicTablePro from './PeriodicTablePro';
import ElectronConfiguration from './ElectronConfiguration';
import AtomBuilderPro from './AtomBuilderPro';
import FillingMap from './FillingMap';

// ATOMIC/PERIODIC cluster registry. WidgetRenderer (owned elsewhere) can spread
// these into its widget-type → component map. Each component takes { config, onComplete }
// and is resilient to partial/empty config.
export const ATOMIC_WIDGETS: Record<
  string,
  React.ComponentType<{ config: any; onComplete?: () => void }>
> = {
  periodic_table_pro: PeriodicTablePro,
  electron_configuration: ElectronConfiguration,
  atom_builder: AtomBuilderPro,
  filling_map: FillingMap,
};

export { PeriodicTablePro, ElectronConfiguration, AtomBuilderPro, FillingMap };
export type { PeriodicTableProConfig } from './PeriodicTablePro';
export type { ElectronConfigurationConfig } from './ElectronConfiguration';
export type { AtomBuilderProConfig } from './AtomBuilderPro';
export type { FillingMapConfig } from './FillingMap';
